import { AiChatMessage, ChatMessageAiAnswerSource, ChatMessageAiCitation } from '@worknet/models';

import { encodeComponentMarker } from '~/shared/utils/componentMarkers';
import { openCitationSource } from '~/shared/utils/linkTarget';

function getDomainFromUrl(url: string) {
  if (!url) {
    return '';
  }
  try {
    return new URL(url).hostname;
  } catch (error) {
    console.error('Invalid URL:', error, url);
    return '';
  }
}

export function getCitationsButtonsData(
  citationsWithParagraph?: ChatMessageAiCitation[],
  sources?: ChatMessageAiAnswerSource[]
) {
  if (!citationsWithParagraph?.length || !sources?.length) {
    return [];
  }

  return (
    citationsWithParagraph?.map(({ citations }) => {
      const groupedBySource =
        citations?.reduce(
          (acc, { citation, sourceIdx }) => {
            if (!acc[sourceIdx]) {
              acc[sourceIdx] = [];
            }
            acc[sourceIdx].push(citation);
            return acc;
          },
          {} as Record<number, string[]>
        ) || {};

      const buttonsData = Object.entries(groupedBySource).map(([sourceIdxStr, citationsArray]) => {
        const sourceIdx = parseInt(sourceIdxStr, 10);
        const source = sources?.find((s) => s.id === sourceIdx) ?? sources?.[sourceIdx];

        const sourcePosition = sources?.indexOf(source!) ?? 0;

        return {
          text: (sourcePosition + 1).toString(),
          onClick: () => source?.url && openCitationSource(source.url),
          toolTip: {
            title: source?.fileRef ? 'Uploaded file' : getDomainFromUrl(source?.url || ''),
            subTitle: source?.title || '',
            body:
              citationsArray.length > 1
                ? `${citationsArray.length}`
                : citationsArray[0]
                  ? `"${citationsArray[0]}"`
                  : ``,
            citations: citationsArray,
            sourceIdx: sourceIdx,
          },
        };
      });

      return buttonsData;
    }) || []
  );
}

export function formatMessageWithCitationMarkers(msg: AiChatMessage): string {
  if ('error' in msg.content) {
    return msg.content.error;
  }

  const paragraphs = msg.content.citations;
  const content = msg.content.message;

  if (!paragraphs?.length) {
    return content;
  }

  let result = content;
  const addedParagraphs = new Set<string>();
  paragraphs.forEach(({ paragraph }, index) => {
    if (addedParagraphs.has(paragraph)) {
      return;
    }
    addedParagraphs.add(paragraph);
    result = result.replaceAll(
      paragraph,
      `${paragraph}${encodeComponentMarker({ kind: 'citeButtons', index })}`
    );
  });
  return result;
}
